module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.tick,
      "alt": "success",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.successPage.title))]), _vm._v(" "), _vm._l((_vm.successPage.copy), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "p"
    }, [_vm._v(_vm._s(copy) + "\n  ")])
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "primary",
      "link": _vm.successPage.buttonLink,
      "label": _vm.successPage.buttonLabel
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00561057"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Success.vue
// module id = 363
// module chunks = 0